import { ProtocoloTipo } from './protocolo-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProtocoloTipoService {

    constructor(private http: Http){}

    getProtocoloTipos(): Observable<ProtocoloTipo[]> {
        return this.http.get(`${NTECH_API}/protocolo-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/protocolo-tipo/protocolo-tipo.service.ts